import React from "react";
import { useTranslation } from "react-i18next";
import { ExecutionStatus, ScenarioStatus } from "./types";
import { EXECUTION_STATUS_CLASS, SCENARIO_STATUS_CLASS } from "./format";

export const ScenarioStatusBadge = ({ status }: { status: ScenarioStatus }) => {
    const { t } = useTranslation(['workflow']);

    return <span className={"badge " + (SCENARIO_STATUS_CLASS[status] || '')}>{t('workflow:scenarioStatus_' + status)}</span>;
};

export const ExecutionStatusBadge = ({ status }: { status: ExecutionStatus }) => {
    const { t } = useTranslation(['workflow']);

    return <span className={"badge " + (EXECUTION_STATUS_CLASS[status] || '')}>{t('workflow:executionStatus_' + status)}</span>;
};
